import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import { compose, withProps, branch, renderNothing, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import moment from 'moment';
import RenderQuestion from "./RenderQuestion";
import DropdownSelect from "../../../../../components/core/input/DropdownSelect";
import InputMultiCheckbox from "../../../../../components/core/input_v2/InputMultiCheckbox";
import TextAreaInput from "../../../../../components/core/input/TextAreaInput";
import TextInput from "../../../../../components/core/input/TextInput";
import componentErrorBoundary from "../../../../../components/enhancers/componentErrorBoundary";
import { capitalize } from '@applyboard/ui-utils';
import CalendarInputWrapper from "../CalendarInputWrapper";
var questionBuilder = function questionBuilder(_ref) {
  var question = _ref.question,
    userPermissions = _ref.userPermissions;
  var questionNum = question.questionNum !== undefined ? "".concat(question.questionNum, ". ") : '';
  var labelText = "".concat(questionNum).concat(capitalize(question.question));
  var component = null;
  var options = null;
  var maxLength = 4000;
  var subLabel = null;
  switch (question.question_format) {
    case 'short_answer':
      component = TextInput;
      maxLength = 500;
      subLabel = "Maximum ".concat(maxLength, " characters");
      break;
    case 'long_answer':
      component = TextAreaInput;
      subLabel = "Maximum ".concat(maxLength, " characters");
      break;
    case 'checkboxes':
      component = InputMultiCheckbox;
      options = question.options.map(function (o) {
        return {
          label: capitalize(o),
          value: o
        };
      });
      break;
    case 'dropdown':
      component = DropdownSelect;
      options = question.options.map(function (o) {
        return {
          label: capitalize(o),
          value: o
        };
      });
      break;
    case 'date':
      component = CalendarInputWrapper;
      break;
    case 'number':
    case 'url':
      component = TextInput;
      maxLength = 500;
      break;
    default:
      break;
  }
  var disabled = !userPermissions.fulfil_requirement || (question.answer ? question.answer.status !== 'normal' : false);
  var rejectionReason = question.answer && question.answer.status === 'disapproved' ? question.answer.status_note : null;
  var rejectionMetaText = rejectionReason && "Rejection Note (".concat(moment(question.answer.updated_at).format('lll'), "):");
  var acceptedMetaText = question.answer && question.answer.status === 'approved' && "Accepted (".concat(moment(question.answer.updated_at).format('lll'), ")");
  var name = question.answer ? "answer-".concat(question.answer.id) : "answer-".concat(question.id);
  if (question.duplicated) {
    name += '-duplicated';
  }
  return {
    acceptedMetaText: acceptedMetaText,
    labelText: labelText,
    component: component,
    options: options,
    name: name,
    disabled: disabled,
    maxLength: maxLength,
    rejectionMetaText: rejectionMetaText,
    rejectionReason: rejectionReason,
    subLabel: subLabel
  };
};
var enhancer = compose(componentErrorBoundary, branch(function (_ref2) {
  var duplicateQuestionsVisible = _ref2.duplicateQuestionsVisible,
    question = _ref2.question;
  return question.duplicated && !duplicateQuestionsVisible;
}, renderNothing), withProps(function (_ref3) {
  var question = _ref3.question,
    userPermissions = _ref3.userPermissions;
  return questionBuilder({
    question: question,
    userPermissions: userPermissions
  });
}), setPropTypes({
  component: PropTypes.func,
  disabled: PropTypes.bool,
  labelText: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  questionNum: PropTypes.number,
  reTryRejections: PropTypes.bool,
  rejectionReason: PropTypes.string,
  userPermissions: PropTypes.object
}));
export default enhancer(RenderQuestion);